// extracted by mini-css-extract-plugin
export default {"bold":"AE9SrjaXO6DGgwnHcBDC"};